import tmhRequest from '@/config/tmhRequest'

export default {

    searchRefundProductOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundproductorder/searchrefundproductorder',
            method: 'post',
            params: data,
        })
    },

    searchRefundProductOrderCount: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundproductorder/searchrefundproductordercount',
            method: 'post',
            data: data,
        })
    },

    searchRefundProductOrderByPage: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundproductorder/searchrefundproductorderbypage',
            method: 'post',
            data: data,
        })
    },

    createRefundProductOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundproductorder/createrefundproductorder',
            method: 'post',
            params: data,
        })
    },

    repairRefundProductOrder: function (data) {
        return tmhRequest({
            url: '/order/refundproductorder/repairrefundproductorder',
            method: 'post',
            params: data,
        })
    },

    refundNotify: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundproductorder/refundnotify',
            method: 'post',
            params: data,
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/ispa/order/refundproductorder.js